import React, { useEffect, useState } from "react"
import axios from 'axios';

import LinkButton from "@components/common/LinkButton"
import LookBookModal from "@components/modal/LookBookModal"
import ProductSwiper from "./Carousel/ProductSwiper"
import { ArrowRight } from "@phosphor-icons/react"

const LookBooksSection = () => {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [bentoItemSelected, setBentoItemSelected] = useState({})
    const [reviews, setReviews] = useState([])

	const handleOnClickCard = (data) => {
		setBentoItemSelected(data)
		setIsModalOpen(true)
	}

    useEffect(() => {
        const fetchReviews = async () => {
            try {
                const reviewData = {
                    skip: 8,
                };
                const response = await axios.post(`/get-instagram-reviews`, reviewData);
                const instaRevews = response?.data?.[0]?.data || [];

                const reviews = instaRevews.map(review => ({
                    image: review.imageThumbnailUrl,
                    name: review.mediaText,
                    title: review.mediaText,
                    buttonLabel: "Shop the look",
                    rawResponse: review,
                }));

                setReviews(reviews)

            } catch (error) {
                setReviews([])
            }
            
        };

        fetchReviews();

    }, []);
    
	return (
		<React.Fragment>
			<section className="max-container mt-14">
				<section className="flex flex-wrap justify-between items-start gap-x-6 flex-col md:flex-row">
					<div>
						<h1>Suit Yourself</h1>
						<p className="mb-4">
							Get inspired by our curated looks. Browse the latest styles and
							see how to wear them for any occasion. 
						</p>
					</div>

					<LinkButton
						label={"Explore Suit Yourself"}
						className={"underline-on-hover"}
						icon={<ArrowRight size={20} weight="light" />}
						to="/suit-yourself/"
					/>
				</section>

				<div className="">
					<ProductSwiper
						products={reviews}
						cardType="lookbook card"
						cardStyles={"lookbook-container-width"}
						spaceBetween={24}
						slidesPerView={4}
						onClickCard={handleOnClickCard}
						breakpoints={{
							// value of key is min-width property
							300: {
								slidesPerView: 2,
								spaceBetween: 16,
							},
							500: {
								slidesPerView: 2,
								spaceBetween: 16,
							},
							640: {
								slidesPerView: 3,
								spaceBetween: 16,
							},
							900: {
								slidesPerView: 4,
							},
							1024: {
								slidesPerView: 4,
							},
						}}
						loop
					/>
				</div>
			</section>

			<LookBookModal
				data={bentoItemSelected}
				isOpen={isModalOpen}
				onClose={() => setIsModalOpen(false)}
			/>
		</React.Fragment>
	)
}

export default LookBooksSection
